import React from 'react';
export default function ReportDescription({header, content, footer, className}){
    return (
            <div className={className}>
                <h4 className='font-secondary'>{header}</h4>
                <p className='budget no-margin font-secondary font-size-24 text-color-dark'>{content}</p>
                <p className='font-primary mt-10'>{footer}</p>
            </div>
    );
}
